import React from 'react';

/* Styled dark-themed checkbox. For binary on/off row settings that aren't
   semantically a "switch" (those still use Toggle). Same hit area as a
   native checkbox but visually consistent with the rest of the dark UI. */
const BOX_BASE = 'relative inline-flex items-center justify-center w-[18px] h-[18px] shrink-0 bg-surface-raised border border-border-strong rounded-[4px] cursor-pointer transition-colors';
const BOX_ON = 'bg-accent-blue border-accent-blue';

export default function Checkbox({ checked, onChange, label, hint, disabled = false, className = '' }) {
  const labelCls = label
    ? 'inline-flex items-center gap-2 cursor-pointer select-none'
    : 'inline-flex items-center cursor-pointer';

  return (
    <label className={`${labelCls} ${disabled ? 'opacity-60 cursor-not-allowed' : ''} ${className}`}>
      <span className={`${BOX_BASE} ${checked ? BOX_ON : ''}`}>
        <input
          type="checkbox"
          className="absolute inset-0 opacity-0 cursor-pointer m-0 disabled:cursor-not-allowed"
          checked={!!checked}
          disabled={disabled}
          onChange={(e) => onChange?.(e.target.checked)}
        />
        {checked && (
          <svg
            viewBox="0 0 16 16"
            className="w-[14px] h-[14px] pointer-events-none text-white"
            aria-hidden
          >
            <path
              d="M3.5 8.5l3 3 6-7"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
          </svg>
        )}
      </span>
      {label && (
        <span className="flex flex-col gap-[2px] text-[0.85rem] text-text">
          <span>{label}</span>
          {hint && <span className="text-[0.73rem] text-text-dim font-normal">{hint}</span>}
        </span>
      )}
    </label>
  );
}
